export const initMovieChapter = () => {
  if (!document.querySelector('.movie-wrap')) return;

  const API_READ = "https://api01-platform.stream.co.jp/apiservice/getMediaByParam/";
  const EQ_TOKEN = "MkQ0QTRBMTEwODI1RDdGQTlBMURDOTdGRERDRDExREM=";
  const videoinfo = {
    mid: document.getElementById('chapterList').dataset.movieId,
    duration: 0,
    title: '',
    poster: '',
    url: ''
  };
  console.log('動画チャプター');

  const player = videojs('videoPlayer', {
    fluid: true,
    fill: true,
    responsive: true,
    language: 'ja',
    disablePictureInPicture: true,
    controlBar: {
      pictureInPictureToggle: false,
      remainingTimeDisplay: {
        displayNegative: false
      }
    }
  }, () => {
    (async function () {
      const res = await fetch(`${API_READ}?token=${EQ_TOKEN}&mid=${videoinfo.mid}&type=json`);
      const data = await res.json();
      const meta = data.meta[0];
      initPlayer(meta);
    })();
  });

  function initPlayer(meta) {
    videoinfo.duration = meta.duration;
    videoinfo.title = meta.title;
    videoinfo.poster = meta.thumbnail_url_ssl;
    videoinfo.url = meta.movie_url.auto_pc.replace(/^https?:/, '');

    document.getElementById('title').innerHTML = videoinfo.title;
    player.src(videoinfo.url);
    player.poster(videoinfo.poster);

    player.on('play', () => {
      if (firstPlay) firstPlay = false;
      if (seekReserved > -1) {
        seekTo(seekReserved);
        seekReserved = -1;
      }
    });

    player.on('timeupdate', () => {
      setCurrentChapter(player.currentTime());
    });

    document.querySelectorAll("#chapterList .chapter").forEach(elm => {
      const sec = time2sec(elm.querySelector(':first-child').textContent);
      elm.addEventListener('click', function () {
        seekTo(sec);
      });
      elm.dataset.sec = sec;
    });
  }

  let firstPlay = true;
  let seekReserved = -1;

  function seekTo(time) {
    if (videoinfo.duration <= time) time = videoinfo.duration;
    if (firstPlay) {
      seekReserved = time;
      player.play();
    } else {
      player.currentTime(time);
    }
  }

  function time2sec(timestr) {
    const time = /^(?<hour>\d{0,2}):?(?<minute>\d{1,2}):(?<second>\d\d)$/.exec(timestr);
    let sec = 0;
    if (time !== null) {
      sec =
        Number(time.groups.hour) * 60 * 60 +
        Number(time.groups.minute) * 60 +
        Number(time.groups.second);
    }
    return sec;
  }

  function setCurrentChapter(sec) {
    sec = parseInt(sec);
    const chapters = Array.from(document.querySelectorAll("#chapterList .chapter")).reverse();
    for (const i in chapters) {
      chapters[i].classList.toggle('current', false);
    }
    for (const i in chapters) {
      if (chapters[i].dataset.sec <= sec) {
        chapters[i].classList.toggle('current', true);
        break;
      }
    }
  }
};
